import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Real-time (WebSocket) o'zgarishni o'zi xabar qiladi; qolgan hollarda 30 soniyada yangilanadi
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (count, error) => {
        if (error instanceof ApiError && error.status < 500) return false;
        return count < 2;
      },
    },
    mutations: { retry: false },
  },
});
